export const quizQuestions = [
  {
    id: "question16",
    videoId: "video16",
    topic: "Driving",
    question: "When I see a max speed limit indicating 40 kph, it means:",
    options: [
      "Don’t go beyond 40kph speed.",
      "Always maintain speed of 40kph",
      "No bus allowed",
    ],
    correctAnswer: "Don’t go beyond 40kph speed.",
    descriptionTitle: "Max Speed Limit",
    description1:
      "A Max Speed Limit traffic sign indicates the maximum speed at which vehicles are allowed to travel on a particular road or section of the road. This sign is typically written in KPH or Kilometers per hour in black numerals.",
    description2:
      "Drivers in the Philippines are legally required to adhere to the posted maximum speed limit on the road where the sign is placed. Exceeding this limit can result in traffic violations, fines, and potential safety hazards. The maximum speed limit is set based on various factors, including road conditions, traffic density, and safety considerations, and it is intended to ensure the safety of all road users. Drivers need to obey these speed limits to prevent accidents and promote safe driving practices.",
  },
  {
    id: "question17",
    videoId: "video17",
    topic: "Driving",
    question: "A stop sign is usually placed:",
    options: [
      "In the middle of the intersection",
      "An Intersection where two or more roads meet",
      "Near an hospital",
    ],
    correctAnswer: "An Intersection where two or more roads meet",
    descriptionTitle: "STOP Sign",
    description1:
      "This sign is used to indicate to drivers that they must come to a complete stop at the marked stop line or, if there is no stop line, at the nearest point where they have a clear view of any oncoming traffic. It is one of the most critical regulatory signs in traffic control.",
    description2:
      "The purpose of a Stop sign is to ensure the safety of all road users by requiring vehicles to halt their movement, allowing other vehicles and pedestrians to proceed safely. It is typically used atintersections where two or more roads meet and where there is a need to manage traffic flow. It's essential for drivers to obey the Stop sign to prevent accidents and collisions at intersections. After coming to a complete stop, drivers should only proceed when it is safe to do so and when they have the right of way according to the rules of the road or any accompanying traffic signals. Failure to stop at a Stop sign can result in traffic violations, fines, and potentially serious accidents.",
  },
  {
    id: "question18",
    videoId: "video18",
    topic: "Driving",
    question: "The symbol for no entry is usually:",
    options: [
      "A red circle with a horizontal white line",
      "A red circle with a cross sign in the middle",
      "A black square with a vertical white line",
    ],
    correctAnswer: "A red circle with a horizontal white line",
    descriptionTitle: "NO ENTRY Sign",
    description1:
      "A No Entry sign is a road traffic sign that conveys a clear and straightforward message: it means that entry is prohibited, and you should not enter the road or path where the sign is displayed. This sign is used to prevent vehicles and pedestrians from entering a particular area or road segment. It is typically a red circle with a white horizontal line running across it, indicating that access is denied or entry is forbidden.",
    description2:
      "The No Entry sign is often placed at the beginning of one-way streets or in areas where traffic is meant to flow in one direction only. When you encounter a No Entry sign, it's essential to obey it and not attempt to enter the restricted area, as doing so can lead to traffic violations, accidents, and unsafe road conditions. Always follow road signs and markings to ensure the safety and orderliness of traffic.",
  },
];
